import { render, staticRenderFns } from "./MultipleChoiceResponse.vue?vue&type=template&id=1369563e&"
import script from "./MultipleChoiceResponse.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports